module.exports = __webpack_public_path__ + "img/fleet.60a20bcd.jpg";